import React from "react";
import { Link } from "react-router-dom";
import { DiscordIcon, FacebookIcon, LinkedInIcon } from "../Icons";
import "./FooterSection.css";

const FooterSection = () => {
  return (
    <section className="bg-gradient-to-tr from-indigo-500 to-red-400  sm:from-indigo-600 sm:to-red-500">
      <div className="curved-footer max-w-screen px-4 py-16 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8 bg-white">
        <nav className="flex flex-wrap justify-center -mx-5 -my-2">
          <div className="px-5 py-2 ">
            <Link
              to="/about"
              className="font-normal bg-gradient-to-br text-gray-400 from-indigo-600 to-red-500 bg-clip-text transition-colors duration-200 hover:text-transparent text-base leading-6"
            >
              About
            </Link>
          </div>

          <div className="px-5 py-2">
            <Link
              to="/contact"
              className="font-normal bg-gradient-to-br text-gray-400 from-indigo-600 to-red-500 bg-clip-text transition-colors duration-200 hover:text-transparent text-base leading-6"
            >
              Contact
            </Link>
          </div>
          <div className="px-5 py-2">
            <Link
              to="/terms"
              className="font-normal bg-gradient-to-br text-gray-400 from-indigo-600 to-red-500 bg-clip-text transition-colors duration-200 hover:text-transparent text-base leading-6"
            >
              Terms
            </Link>
          </div>
        </nav>
        <div className="flex justify-center mt-8 space-x-6 text-lg">
          <a
            href="https://www.facebook.com/groups/902811997286238/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-gray-500"
          >
            <span className="sr-only">Facebook</span>
            <FacebookIcon />
          </a>
          <a
            href="https://discord.com/invite/MMYUXPqjwx"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-gray-500"
          >
            <span className="sr-only">Discord</span>
            <DiscordIcon />
          </a>
          <a
            href="https://www.linkedin.com/groups/13999769/"
            target="_blank"
            rel="noreferrer"
            className="text-gray-400 hover:text-gray-500"
          >
            <span className="sr-only">LinkedIn</span>
            <LinkedInIcon />
          </a>
        </div>
        <p className="mt-8 text-base leading-6 text-center text-gray-400">
          © 2021 Zofium.com All rights reserved.
        </p>
      </div>
    </section>
  );
};

export default FooterSection;
